import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getInsuranceTypesList } from "../../../../../../../services/tasyInsuranceType.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const ProcedureType = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(getInsuranceTypesList);

  const [procedureType, setProcedureTypes] = useState<ISelectType[]>([]);

  const params = useMemo(() => {
    return {
      Identifier: 95,
    };
  }, []);

  const fetchProcedureType = useCallback(async () => {
    const { data, success } = await sendRequest(params);
    if (data && success) {
      const newData = data.map((item) => ({
        id: item.identifierValue,
        name: item.domainValueName,
      }));

      setProcedureTypes(newData);
    }
  }, [sendRequest, params]);

  useEffect(() => {
    fetchProcedureType();
  }, [fetchProcedureType]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoCompleteMulti
        options={procedureType}
        name="uBusIntegrationRuleMovProcedTypes"
        size="small"
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "procedure_type")}
        keepOpenOnSelect
      />
    </Grid>
  );
});
